// import React, { Component } from 'react';
// import OwlCarousel from 'react-owl-carousel';
// import 'owl.carousel/dist/assets/owl.carousel.css';
// import 'owl.carousel/dist/assets/owl.theme.default.css';

// // import '../assets/css/main.css';

// // image path 
// import issue1 from '../assets/images/website/issue1.png';
// import issue2 from '../assets/images/website/issue2.png';
// import issue3 from '../assets/images/website/issue3.png';
// import issue4 from '../assets/images/website/issue4.png';
// import issue5 from '../assets/images/website/issue5.png';
// import issue6 from '../assets/images/website/issue6.png';
// import issue7 from '../assets/images/website/issue7.png';
// import issue8 from '../assets/images/website/issue8.png';

// class LogoSlider extends Component {
//     constructor(props) {
//         super(props);
//         this.logos = [
//             { 'image': issue1, 'name': 'Urinary Issues' },
//             { 'image': issue2, 'name': 'Kidney Issues' },
//             { 'image': issue3, 'name': 'Brain and Nerves' },
//             { 'image': issue4, 'name': 'Heart' },
//             { 'image': issue5, 'name': 'Dental Care' },
//             { 'image': issue6, 'name': 'Ear Nose Throat' },
//             { 'image': issue7, 'name': 'Digestive' },
//             { 'image': issue8, 'name': 'Cancer' },
//         ];

//         this.owlOptions = {
//             items: 6,
//             autoplay: true,
//             autoplayTimeout: 1000,
//             loop: true,
//             margin: 10,
//             responsive: {
//                 0: {
//                     items: 1,
//                 },
//                 600: {
//                     items: 3,
//                 },
//                 1000: {
//                     items: 6,
//                 },
//             },
//         };
//     }

//     render() {
//         return (
//             <div className='container-95'>
//                 <OwlCarousel className="owl-theme" {...this.owlOptions}>
//                     {this.logos.map((logo, index) => (
//                         <div key={index} className='py-4 logo-slide text-center'>
//                             <div className='logo-image'>
//                                 <img src={logo.image} alt={logo.name} className='w-25 h-100' />
//                             </div>
//                             <h1 className='mt-3'>{logo.name}</h1>
//                         </div>
//                     ))}
//                 </OwlCarousel>
//             </div>
//         );
//     }
// }

// export default LogoSlider;

import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import axios from 'axios'; // Make sure to import axios
import { CONFIG } from "../config/data";
import { getDateISOFormat, getPatientsubstring } from "../constants/globalLevelFunctions";
import { getDocByBusinesswithspeciality, getdoctordetails, getpaymenttypeforbusiness} from  "../config/url.json"; // Adjust the import based on your project structure

// image path 
import issue1 from '../assets/images/website/issue1.webp';
import issue2 from '../assets/images/website/issue2.webp';
import issue3 from '../assets/images/website/issue3.webp';
import issue4 from '../assets/images/website/issue4.webp';
import issue5 from '../assets/images/website/issue5.webp';
import issue6 from '../assets/images/website/issue6.webp';
import issue7 from '../assets/images/website/issue7.webp';
import issue8 from '../assets/images/website/issue8.webp';

class LogoSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            searchData: {
                speciality: props.searchData ? props.searchData.speciality : "",
            },
            loading: false,
            doctor_list: [],
            queuein_data: {},
            doctor_appointment_detail_list: [],
            selected_doc: null,
            selected_doctor_appointment_detail_list: [],
            selected_doc_schedule_type: null,
            doctor_details: null,
            openModal: false,
            paymenttypeforhospital: null,
        };

        this.logos = [
            { 'image': issue1, 'name': 'Urinary Issues' },
            { 'image': issue2, 'name': 'Kidney Issues' },
            { 'image': issue3, 'name': 'Brain and Nerves' },
            { 'image': issue4, 'name': 'Heart' },
            { 'image': issue5, 'name': 'Dental Care' },
            { 'image': issue6, 'name': 'Ear Nose Throat' },
            { 'image': issue7, 'name': 'Digestive' },
            { 'image': issue8, 'name': 'Cancer' },
        ];

        this.owlOptions = {
            items: 6,
            autoplay: true,
            autoplayTimeout: 1000,
            autoplayHoverPause: true,
            loop: true,
            margin: 10,
            responsive: {
                0: {
                    items: 1,
                },
                600: {
                    items: 3,
                },
                1000: {
                    items: 6,
                },
            },
        };
    }

    handleSpecialitySelectChange = (selectedOptions, e) => {
        let data = this.state.searchData;
        data[e.name] = selectedOptions;
        data.latitude = this.state.latitude;
        data.longitude = this.state.longitude;
        this.setState({ searchData: data });
    };

    showFamilyDetail = (value, el) => {
        this.setState({ loading: true });
        const specialityValue = this.state.searchData.speciality.value;

        const data = {
            n_business_id: value.user_id,
            n_currentdate: getDateISOFormat(new Date()),
            speciality: specialityValue,
        };

        console.log(data);
        if (value.user_id !== "") {
            axios.defaults.headers.common["Authorization"] = `Bearer ${this.props.access_token}`;
            axios.post(getDocByBusinesswithspeciality, data, CONFIG)
                .then((result) => {
                    let resData = result.data.data;
                    console.log(result);
                    console.log(resData);
                    let queuein_data = {
                        n_business_id: value.user_id,
                        business_name: value.business_name,
                        address: value.address1 + " " + value.city,
                        expected_wait_time: value.expected_wait_time,
                    };

                    let doctor_appointment_detail_list = [];
                    let docList = [];

                    if (resData) {
                        resData.forEach((element) => {
                            let doctor_obj = {
                                doc_name: element.doctor_name,
                                business_user_id: element.business_user_id,
                                schedule_day_id: element.schedule_day_id,
                                schedule_id: element.schedule_id,
                                schedule_type: element.schedule_type,
                                appt_id: element.appt_id,
                                doctor_Appointments: element.doctor_Appointments,
                            };

                            doctor_appointment_detail_list.push(doctor_obj);
                            docList.push({
                                value: element.business_user_id,
                                speciality_name: element.speciality_name,
                                label: element.doctor_name,
                            });
                        });
                    }

                    console.log(docList);

                    this.setState({
                        doctor_list: docList,
                        queuein_data: queuein_data,
                        doctor_appointment_detail_list: doctor_appointment_detail_list,
                    });

                    // By default select on doctor
                    let selected_doc = docList[0];
                    let selected_appointment = [];
                    let selected_doc_schedule_type = this.state.selected_doc_schedule_type;

                    // Based on default doctor selection select corresponding appointment details
                    doctor_appointment_detail_list.forEach((element) => {
                        if (element.business_user_id === docList[0].value) {
                            selected_appointment = element.doctor_Appointments;
                            selected_doc_schedule_type = element.schedule_type;
                        }
                    });

                    this.setState({
                        selected_doc: selected_doc,
                        selected_doctor_appointment_detail_list: selected_appointment,
                        selected_doc_schedule_type: selected_doc_schedule_type,
                    });

                    // Fetch doctor details
                    axios.post(getdoctordetails, { business_id: this.state.queuein_data.n_business_id, business_user_id: docList[0].value }, CONFIG)
                        .then((res) => {
                            let response = res.data;
                            console.log(response);
                            if (response.status !== "0") {
                                this.setState({ doctor_details: response.data });
                            }
                        })
                        .catch((e) => {
                            console.log(e);
                        });

                    // Fetch payment type for the hospital
                    axios.post(getpaymenttypeforbusiness, { user_id: value.user_id }, CONFIG)
                        .then((res) => {
                            let data = res.data;
                            console.log(res);
                            if (data.status === "1") {
                                this.setState({
                                    paymenttypeforhospital: data.data[0].payment_type,
                                });
                            }
                        })
                        .catch((e) => {
                            console.log(e);
                        });

                    this.setState({ openModal: true, loading: false });
                })
                .catch((e) => {
                    console.log(e);
                    this.setState({ loading: false });
                });
        }
    };

    handleLogoClick = (logo) => {
        // Assuming each logo corresponds to a specific business or service
        // You can replace this with the actual logic to get the business details
        const selectedBusiness = {
            user_id: logo.value, // Replace with actual user_id if available
            business_name: logo.name, // Replace with actual business name if available
            address1: "123 Main St", // Replace with actual address if available
            city: "Sample City", // Replace with actual city if available
            expected_wait_time: "15 mins", // Replace with actual wait time if available
        };

        this.showFamilyDetail(selectedBusiness);
    };

    render() {
        // Extract specialities from props
        let specialities_array = this.props.appdata
            ? this.props.appdata[0].specialities
            : [];
        let specialities = [];
        specialities_array.forEach((element) => {
            specialities.push({ value: element.id, label: element.name });
        });
        specialities_array = specialities;

        return (
            <div className='container-95'>
                {/* Display specialities as a list */}
                <div className="specialities-list">
                    <ul>
                        {specialities_array.map((speciality) => (
                            <li key={speciality.value}>{speciality.label}</li>
                        ))}
                    </ul>
                </div>

                <OwlCarousel className="owl-theme" {...this.owlOptions}>
                    {this.logos.map((logo, index) => (
                        <div key={index} className='py-4 logo-slide text-center' onClick={() => this.handleLogoClick(logo)}>
                            <div className='logo-image'>
                                <img src={logo.image} alt={logo.name} className='w-25 h-100' />
                            </div>
                            <h1 className='mt-3'>{logo.name}</h1>
                        </div>
                    ))}
                </OwlCarousel>
            </div>
        );
    }
}

export default LogoSlider;